import { render, staticRenderFns } from "./PublicProfileEditor.vue?vue&type=template&id=4de8556c"
import script from "./PublicProfileEditor.vue?vue&type=script&lang=js"
export * from "./PublicProfileEditor.vue?vue&type=script&lang=js"
import style0 from "./PublicProfileEditor.vue?vue&type=style&index=0&id=4de8556c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports